<template>
 <div class="product-header">
  <div class="product-header-content">
   <div class="product-header-content-title">新闻中心</div>
   <div class="product-header-content-jianjie">
    我们聚焦矿山智能化、工业物联网及安全监测领域的前沿发展，及时传递企业创新成果、项目案例及行业政策解读。</div>
   <div>
    <!-- <a-button class="learnmore-btn" type="primary" @click="$router.push('/serve')">联系我们</a-button> -->
   </div>

  </div>
 </div>
 <div class="product-header-mobile">
  <div class="product-header-content-mobile">
   <div class="product-header-content-title-mobile">新闻中心</div>
   <div class="product-header-content-jianjie-mobile ">
    聚焦矿山智能化、工业物联网及安全监测领域的前沿发展，传递企业创新成果、项目案例及行业政策解读 </div>
   <div>
    <!-- <a-button class="learnmore-btn" type="primary" @click="$router.push('/serve')">联系我们</a-button> -->
   </div>

  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import learnmore from "@/components/learnmore.vue"

const dataInfo = ref(null)

const img_url = ref("")

const getImgUrl = (item) => {
 if (item['picture-upload3bc511cf'] && item['picture-upload3bc511cf'].length > 0) {
  return item['picture-upload3bc511cf'][0].url
 } else {
  return ""

 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 1,
  worksheetId: "6811830c88d9150586aae434",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataInfo.value = res.data[0]
  img_url.value = `url(${getImgUrl(dataInfo.value)})`
 }

}

onMounted(() => {
 // getData()
})


</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .product-header {
  display: none !important;
 }

 .product-header-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .product-header {
  display: flex !important;
 }

 .product-header-mobile {
  display: none;
 }
}

.product-header-content-mobile {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 225px;
 background: url("../../assets/image/home/xwzxMobile.png") no-repeat;
 background-size: 100% 100%;
 display: flex;
 flex-direction: column;
 justify-content: center;
}

.product-header {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 450px;
 background: url("../../assets/image/home/xwzx.png") no-repeat;
 background-size: 100% 100%;
 display: flex;
 justify-content: center;
}

.product-header-content {
 width: 100%;
 height: 100%;
 margin-left: 18%;
 padding-top: 170px;
}

.product-header-content-title {
 font-size: 36px;
 font-weight: 500;
}

.product-header-content-jianjie {
 width: 800px;
 font-size: 16px;
 margin-top: 20px;
 margin-bottom: 60px;
}

.product-header-content-jianjie-mobile {
 width: 70%;
 font-size: 14px;
 margin-top: 10px;
 padding: 0 20px;
}

.product-header-content-title-mobile {
 font-size: 26px;
 font-weight: 500;
 margin-top: 20px;
 padding: 0 20px;
}

.learnmore-btn {

 width: 210px;
 height: 46px;
 border-radius: 10px;
}
</style>